<!-- User Upload Article Text -->

<template>
	<div class="upload-txt-main">
		<div class="lab-box">Category:</div>
		<CatPickBtn step="upload"/> 

		<div class="v-spacer" />
		<div class="v-spacer" />

		<div class="lab-box">Author:</div>
		<div class="pop-value-box" @click="popInput('credit')" v-html="convertLFs(rec.credit)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Title:</div>
		<div class="pop-value-box" @click="popInput('title')" v-html="convertLFs(rec.title)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Story:</div>
		<div class="pop-value-box pop-textarea" @click="popInput('fullTxt')" v-html="convertLFs(rec.fullTxt)"></div>

		<div class="v-spacer" />
		<div class="v-spacer" />

		<div class="clear-lab wi8_font">
			Clear Story:
		</div>

		<div class="clear-btn" @click="clickClear">
			<UniIcon 
				ico="cancel" 
				color="#C30" 
				fit="1"
				pad="4"
			/>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils"
import CfgApp from "@/assets/cfg/CfgApp";
import * as Utils from "@/utils/utils";
import { mapState } from 'vuex';
import { eventBus } from '@/main';
export default {
	data() {
		return {
			step: "upload",
			cat: {},
			rec: {
				credit: "",
				title: "",
				story: "",
			},
		};
	},
	computed: {
		...mapState('app',['upload']),
	},
	methods: {
		popInput(colName) {
			Utils.showPopInput(colName, this.rec[colName]);
		},
		handleUpdateVal(payload) {
			let colName = payload.colName;
			let val = payload.val;
			this.rec[colName] = val;
		},
		convertLFs(str1="") {
			m("convert LFs", str1);
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		clickClear() {
			m("click clear");
			let data = {
				step: this.step,
			};
			this.$store.dispatch("app/setCat", data)
			.then(() => {
				this.$store.dispatch("app/setArt", data);
			});
		},
		setCat() {
			m("up txt set cat", this.cat);
			this.rec.cat = this.cat;
			this.rec.catId =  this.cat.itemId;
			this.rec.catItemId = this.cat.itemId;
			this.rec.catTitle = this.cat.title;
			m("up txt rec 1", this.rec);
		},
		updateRec() {
			m("update rec");
			const data = {
				step: "upload",
				art: this.rec,
			};
			this.$store.dispatch("app/setArt", data);
		},
	},
	mounted() {
		m("up txt mounted");
		this.cat = {...this.upload.cat};
		this.rec = {...this.upload.art};
		this.setCat();
		m("up txt rec 2", this.rec);
		m("up txt cat", this.cat);
	},
	created() {
		m("build created");
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		m("upload txt bef destroy");
		this.updateRec();
		eventBus.$off('update-value', this.handleUpdateVal);
	},
	watch: {
		"upload.cat": {
			handler(newVal, oldVal) {
				m("up txt old cat", oldVal);
				m("up txt new cat", newVal);
				this.cat = {...newVal};
				this.setCat();
			}
		},
		"upload.art"(newVal, oldVal) {
			m("up txt watch upload art", newVal);
			this.rec = {...newVal};
		}
	},
}
</script>

<style scoped>

.upload-txt-main {
	height: 100%;
	overflow: hidden;
	padding: 20px;
	border: solid 0px #C30;
}

.lab-box {
	display: inline-block;
	width: 80px;
	height: 22px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	border: solid 0px #369;
}

.pop-value-box {
	display: inline-block;
	width: 250px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.pop-textarea {
	height: 120px;
	width: 310px;
	overflow-x: none;
	overflow-y: auto;
}


.v-spacer {
	width: 10px;
	height: 10px;
	vertical-align: top;
	border: solid 0px #999;
}

.bot-line {
	height: 40px;
	overflow: hidden;
	border: solid 0px #369;
}

.clear-lab {
	display: inline-block;
	width: 120px;
	height: 36px;
	overflow: hidden;
	vertical-align: top;
	padding: 5px;
	border: solid 0px #090;
}

.clear-btn {
	display: inline-block;
	width: 36px;
	height: 36px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	border: solid 0px #369;
}


input {
	width: 100%;
}

textarea {
	/* all: initial; */
	width: 100%;
	height: 100%;
	/* resize: none; */
}

</style>
